import { PayloadAction } from '@reduxjs/toolkit';
import { ICompanyDetail, IProduct, IFormsInfo } from '../../auth/interfaces/ICompanyDetail';

export const CompanyDetailReducer = {
  setCompanyDetail: (
    state: ICompanyDetail,
    action: PayloadAction<ICompanyDetail>
  ) => {
    return { ...action.payload };
  },
  
  updateProducts: (
    state: ICompanyDetail,
    action: PayloadAction<IProduct[]>
  ) => {
    state.products = action.payload;
  },
  
  updateFormsInfo: (
    state: ICompanyDetail,
    action: PayloadAction<IFormsInfo>
  ) => {
    state.forms_info = action.payload;
  }
}; 